import { RiskFieldsTypeEnum } from '@/__generated__/graphql';
import Stack from '@mui/material/Stack';
import { ConsequenceOfFailure } from '../ConsequenceOfFailure';
import { ProbabilityOfFailure } from '../ProbabilityOfFailure';
import { Review } from '../Review';
import { TransitionPeriod } from '../TransitionPeriod';
import { TabPill } from './styles';

export const RiskAssessmentTabsHeader = ({
  selectedTab,
  level1Selected,
  onTabClick,
}: {
  selectedTab: string;
  level1Selected: boolean;
  onTabClick: (button: string) => void;
}) => {
  return (
    <Stack direction="row" gap={2}>
      <TabPill
        data-testid="pof-fab"
        disabled={!level1Selected && selectedTab === ''}
        variant="text"
        size="small"
        onClick={() => onTabClick(RiskFieldsTypeEnum.Pof)}
        selected={selectedTab === RiskFieldsTypeEnum.Pof}
      >
        POF Editor
      </TabPill>
      <TabPill
        data-testid="cof-fab"
        disabled={!level1Selected && selectedTab === ''}
        variant="text"
        size="small"
        onClick={() => onTabClick(RiskFieldsTypeEnum.Cof)}
        selected={selectedTab === RiskFieldsTypeEnum.Cof}
      >
        COF Editor
      </TabPill>
      <TabPill
        data-testid="transition-period-fab"
        disabled={!level1Selected && selectedTab === ''}
        variant="text"
        size="small"
        onClick={() => onTabClick(RiskFieldsTypeEnum.TransitionPeriod)}
        selected={selectedTab === RiskFieldsTypeEnum.TransitionPeriod}
      >
        Transition Period
      </TabPill>
      <TabPill
        data-testid="review-fab"
        disabled={!level1Selected && selectedTab === ''}
        variant="text"
        size="small"
        onClick={() => onTabClick(RiskFieldsTypeEnum.Review)}
        selected={selectedTab === RiskFieldsTypeEnum.Review}
      >
        Risk Matrix
      </TabPill>
    </Stack>
  );
};

export const RiskAssessmentTabDetails = ({
  selectedTab,
  updateAllAssemblies,
}: {
  selectedTab: string;
  updateAllAssemblies: boolean;
}) => {
  return (
    <>
      <ProbabilityOfFailure
        updateAllAssemblies={updateAllAssemblies}
        selected={selectedTab === RiskFieldsTypeEnum.Pof}
      />

      <ConsequenceOfFailure
        updateAllAssemblies={updateAllAssemblies}
        selected={selectedTab === RiskFieldsTypeEnum.Cof}
      />

      <TransitionPeriod
        updateAllAssemblies={updateAllAssemblies}
        selected={selectedTab === RiskFieldsTypeEnum.TransitionPeriod}
      />

      <Review selected={selectedTab === RiskFieldsTypeEnum.Review} />
    </>
  );
};
